// Fetch a new result from the autocomplete API, updating the results state
export async function fetchAutocompleteResults(query: string) {
  if (query.length < 2) {
    return [];
  }
  const res = await fetch(
    `${process.env.NEXT_PUBLIC_SEARCH_ENDPOINT}/here/search/${query}`,
  );

  return await res.json();
}
